import { render, staticRenderFns } from "./Billboard.vue?vue&type=template&id=44970cce&scoped=true"
import script from "./Billboard.vue?vue&type=script&lang=ts"
export * from "./Billboard.vue?vue&type=script&lang=ts"
import style0 from "./Billboard.vue?vue&type=style&index=0&id=44970cce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44970cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44970cce')) {
      api.createRecord('44970cce', component.options)
    } else {
      api.reload('44970cce', component.options)
    }
    module.hot.accept("./Billboard.vue?vue&type=template&id=44970cce&scoped=true", function () {
      api.rerender('44970cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/Billboard.vue"
export default component.exports